import React from 'react';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import gfm from 'remark-gfm';
import { useInView } from 'react-intersection-observer';
import 'animate.css';
import { animationClass, animationStyle } from '../../../utils/FadeInEffect';
import { SOURCE_URL } from '../../../config';

interface BusinessFullScreenTemplateProps {
    element: any
}

const BusinessFullScreenTemplate: React.FC<BusinessFullScreenTemplateProps> = (element) => {

    const { ref, inView } = useInView({
        threshold: 0.1,
        triggerOnce: true,
    });

    const bottomBannerImage = element?.element?.BottomBannerImage?.data?.attributes?.url;
    const bottomBannerImageTab = element?.element?.BottomBannerImageTab?.data?.attributes?.url ?? bottomBannerImage;
    const bottomBannerImageMob = element?.element?.BottomBannerImageMob?.data?.attributes?.url ?? bottomBannerImageTab;

    const bottomBannerImagePosition = element?.element?.BottomBannerImagePosition?.replace(" - ", " ").toLowerCase();

    return (
        <>  
        <section id="bottom-banner" className="object-item" data-imgposition={bottomBannerImagePosition}>
            <img style={{objectPosition:bottomBannerImagePosition}} className="w-100 img-fit object-desktop-image img-fit d-xl-block d-none lazyload" src={SOURCE_URL + bottomBannerImage} />
            <img style={{objectPosition:bottomBannerImagePosition}} className="w-100 img-fit object-tab-image img-fit d-xl-none d-lg-block d-none lazyloaded" src={SOURCE_URL + bottomBannerImageTab} />
            <img style={{objectPosition:bottomBannerImagePosition}} className="w-100 img-fit object-mobile-image img-fit d-lg-none d-block lazyload" src={SOURCE_URL + bottomBannerImageMob} />
            <div ref={ref} className={`prc banner-${element?.element?.BottomBannerTextPosition?.toLowerCase()} banner-text ${element?.element?.BottomTextColor == "Light" ? "white" : "black"}-color ${animationClass(inView, 'right')}`} style={animationStyle(inView,'right')}>
                <ReactMarkdown remarkPlugins={[gfm]} rehypePlugins={[rehypeRaw]}>{element?.element?.BottomBannerText}</ReactMarkdown>
                {element?.element?.BannerButtonLink?.URL && <a className="default-btn" href={element?.element?.BannerButtonLink?.URL} target={element?.element?.BannerButtonLink?.OpenLinkInANewTab ? '_blank' : '_self'}>{element?.element?.BannerButtonLink?.LinkText}</a>}
            </div>
        </section>
        </>
    );
}
export default BusinessFullScreenTemplate;